<div (click)="exportCSV()" class="grid-export hover-bigger-less">
    <img alt="csv export" [src]="CONSTS.ICON_URL.CSV_EXPORT"/>
</div>
